const BASE_URL = process.env.REACT_APP_API_URL;
const STRIPE_KEY = process.env.REACT_APP_STRIPE_SECRET_KEY;

const handleResponse = async (response) => {
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return await response.json();
};

const getHeaders = (token) => ({
  'Content-Type': 'application/json',
  ...(token && { 'Authorization': `Bearer ${token}` })
});

export const paymentService = {

  getDataMe: async (token) => {
    try {
      const response = await fetch(`${BASE_URL}/users/me-full`, {
        method: 'GET',
        headers: getHeaders(token)
      });
      return handleResponse(response);
    } catch (error) {
      throw error;
    }
  },

  getCustomerId: async (body, token) => {
    try {
      const response = await fetch(`${BASE_URL}/payment-methods/`, {
        method: 'POST',
        headers: getHeaders(token),
        body: JSON.stringify(body)
      });
      return handleResponse(response);
    } catch (error) {
      throw error;
    }
  },

  assignPaymentMethod: async (paymentMethodId, customerId) => {
    try {
        const url = `https://api.stripe.com/v1/payment_methods/${paymentMethodId}/attach`;
        const headers = {
            'Authorization': `Bearer ${STRIPE_KEY}`,
            'Content-Type': 'application/x-www-form-urlencoded'
        };
        const body = `customer=${customerId}`;
        const response = await fetch(url, {
            method: 'POST',
            headers,
            body
        });

        const jsonResponse = await response.json();
        return jsonResponse;
    } catch (error) {
        console.error('Error al guardar la tarjeta:', error);
        return null;
    }
  },

  getPackages: async (token) => {
    try {
      const response = await fetch(`${BASE_URL}/tokens/packs`, {
        method: 'GET',
        headers: getHeaders(token)
      });
      return handleResponse(response);
    } catch (error) {
      throw error;
    }
  },

  getMovements: async (token, userId, page = 1, items_per_page = 10) => {
    try {
      const response = await fetch(`${BASE_URL}/tokens/operations-history/user/${userId}?page=${page}&items_per_page=${items_per_page}`, {
        method: 'GET',
        headers: getHeaders(token)
      });
      return handleResponse(response);
    } catch (error) {
      throw error;
    }
  },

  getDataPurchase: async (token, userId) => {
    try {
      const response = await fetch(`${BASE_URL}/tokens/balance/user/${userId}`, {
        method: 'GET',
        headers: getHeaders(token)
      });
      return handleResponse(response);
    } catch (error) {
      throw error;
    }
  },

  getPaymentMethods: async (token, userId) => {
    try {
      const response = await fetch(`${BASE_URL}/payment-methods/user/${userId}`, {
        method: 'GET',
        headers: getHeaders(token)
      });
      return handleResponse(response);
    } catch (error) {
      throw error;
    }
  },

  purchasePackage: async (token, packageId) => {
    try {
      const response = await fetch(`${BASE_URL}/payments/`, {
        method: 'POST',
        headers: getHeaders(token),
        body: JSON.stringify({
          token_pack_id: packageId
        })
      });
      return handleResponse(response);
    } catch (error) {
      throw error;
    }
  },

  confirmPaymentIntent: async (paymentMethodId, paymentIntentId) => {
    try {
        const url = `https://api.stripe.com/v1/payment_intents/${paymentIntentId}/confirm`;
        const headers = {
            'Authorization': `Bearer ${STRIPE_KEY}`,
            'Content-Type': 'application/x-www-form-urlencoded'
        };
        const body = `payment_method=${paymentMethodId}`;
        const response = await fetch(url, {
            method: 'POST',
            headers,
            body
        });
        const jsonResponse = await response.json();
        return jsonResponse;
    } catch (error) {
        console.error('Error al guardar la tarjeta:', error);
        return null;
    }
  },

  setDefaultPaymentMethod: async (paymentMethodId, userId, token) => {
    try {
      const response = await fetch(`${BASE_URL}/payment-methods/${paymentMethodId}/user/${userId}/default`, {
        method: 'PUT',
        headers: getHeaders(token),
        body: JSON.stringify({
          payment_method_id: paymentMethodId
        })
      });
      return handleResponse(response);
    } catch (error) {
      throw error;
    }
  },

  getDataUser: async (token) => {
    try {
      const response = await fetch(`${BASE_URL}/users/me`, {
        method: 'GET',
        headers: getHeaders(token)
      });
      return handleResponse(response);
    } catch (error) {
      throw error;
    }
  },
}
